import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import React, { useEffect, useState } from 'react'
import useMap from 'tennders-transactions/hooks/useMap'
import useOffer from 'tennders-market/offer/hooks/useOffer'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import { GInput } from 'tennders-common/form/components'
import { calculateRouteDistance } from 'tennders-stracture/libs/utils'
import { useToast } from 'tennders-common/hooks/useToast'
import GHref from 'tennders-market/common/components/element/GHref'
import GCurrency from 'tennders-market/common/components/element/GCurrency'
import DistanceInKm from 'tennders-common/components/DistanceInKM'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import OfferSentMessage from '../../../market/offer/views/first-offer/OfferSentMessage'

const LoadOffer = ({ truckTransaction, loadTransaction, onRefresh }) => {
  const [form, setform] = useState({})
  const [step, setstep] = useState(0)
  const [submitting, setsubmitting] = useState(false)
  const {
    makeOffer, errors, setShowRouteOf,
    setOfferingToLoad, savingRoute
  } = useOffer()
  const {
    mapForm,
    setMapForm,
    setEditMode,
    setSelectedDistance,
    selectedDistance,
    setRouteSelectable,
    selectedRoute,
    mapProps,
    getMapProps
  } = useMap()
  const { t } = useTranslation()
  const { toastSuccess } = useToast()
  const { refreshTransaction } = useTransactions()
  // const { setTransaction, fetchTransaction } = useTransaction();
  const onChange = (k, v) => {
    setform({ ...form, [k]: v })
  }
  useEffect(() => {
    if (mapProps?.content) {
      setShowRouteOf(loadTransaction)
    }
  }, [mapProps])

  const initMap = async () => {
    await getMapProps(loadTransaction?.id, true)
  }

  useEffect(() => {
    setSelectedDistance(0)
    initMap()
    return () => {
      setMapForm({})
      setSelectedDistance(0)
      setstep(0)
      setEditMode(false)
      setShowRouteOf(false)
    }
  }, [loadTransaction])

  const sendBid = async () => {
    setsubmitting(true)

    setTimeout(async () => {
      const params = {
        ...form,
        ...mapForm,
        truck: truckTransaction?.matchedTruck?.id,
        truckPickupRoute: truckTransaction?.matchedTruck?.pickupRoute,
        route: selectedRoute?.route,
        routeDetails: selectedRoute?.routeDetails,
        saveCallback: selectedRoute?.save
      }

      if (selectedRoute?.distance || selectedDistance) {
        params.distance = selectedRoute?.distance || selectedDistance
      }
      const response = await makeOffer(loadTransaction, params)

      if (response?.id) {
        toastSuccess('Offer is sent')
        setstep(3)
        onRefresh()
        refreshTransaction()
      }

      setsubmitting(false)

      setOfferingToLoad(false)
    }, 50)

    // setTransaction(false);
    // const newTransaction = await fetchTransaction(loadTransaction?.id);
    // setTransaction(newTransaction);
  }

  useEffect(() => {
    if (step > 1) {
      setRouteSelectable(false)
    }
  }, [step])

  useEffect(() => {
    setstep(0)
    setEditMode(true)
  }, [loadTransaction])

  const reset = () => {
    setform({})
    setstep(0)
  }

  useEffect(() => {
    if (mapForm?.pickupRoute && Object.keys(mapForm?.pickupRoute).length > 0) {
      calculateRouteDistance([truckTransaction?.pickupRoute, mapForm?.pickupRoute], (result) => {
        if (result?.distance) {
          setform({ ...form, emptyKm: result?.distance })
          setMapForm({ ...mapForm, emptyKm: result?.distance })
        }
      })
    }
  }, [mapForm?.pickupRoute])

  useEffect(() => {
  }, [selectedRoute])

  const isRouteOffered = mapForm?.pickupRoute && mapForm?.deliveryRoute
  return (

    <tr>
      <td colSpan="2" className="tennders-offer-panel-table w-100 p-0 pos-rel">
        <div className="w-90 bg-color-white pos-rel p-8">
          <div className="d-flex align-center justify-space pos-rel border-b">
            <div className="w-50">
              <div className="p-10">
                <div className="d-flex align-center">
                  <div className="step-no mr-10">1</div>
                  <div className="flex-1">{t('transaction:fillInfoPrompt')}</div>
                </div>
              </div>
            </div>
            <div className="w-50 text-right">
              <div className="p-10">
                <GHref
                  disabled={!isRouteOffered}
                  onClick={() => setstep(1)}
                  className="btn standard-btn small bold confirm-step-btn"
                >
                  {t('transaction:confirmPickUpDelivery')}
                </GHref>
              </div>
            </div>
            {step > 0 ? (
              <div className="checked-step">
                <FontAwesomeIcon icon={faCheck} fontSize={24} aria-hidden="true" />
              </div>
            ) : null}
          </div>
          <div className="d-flex justify-space pos-rel border-b">
            <div className="w-100">
              <div className="p-10">
                <div className="d-flex">
                  <div className="step-no mr-10">2</div>
                  <div className="flex-1">
                    <p>
                      {t('transaction:confirmSelectedRoute')}                      <br />
                      {t('transaction:dragBetween')}                      <br />

                    </p>
                    <p>
                      {t('transaction:selectedDistance')}  :
                      {' '}
                      {' '}
                      <strong>
                        <DistanceInKm value={selectedDistance} />
                      </strong>
                    </p>
                    {form?.emptyKm && (
                      <p>
                        {t('transaction:emptyKmDistance')}  :
                        {' '}
                        <strong>
                          <DistanceInKm value={form?.emptyKm} />
                        </strong>
                      </p>
                    )}
                  </div>

                </div>
                <div className="ml-40">
                  <div>
                    <GHref
                      onClick={() => setstep(2)}
                      disabled={step < 1 || !selectedRoute}
                      className="btn standard-btn small  bold confirm-step-btn-2"
                    >
                      {t('transaction:confirmRoute')}
                    </GHref>
                  </div>
                </div>
              </div>
            </div>
            {step > 1 && (
              <div className="checked-step">
                <FontAwesomeIcon icon={faCheck} fontSize={24} aria-hidden="true" />
              </div>
            )}
          </div>
          <div className="d-flex justify-space pos-rel border-b">
            <div>
              <div className="p-10">
                <div className="d-flex align-center">
                  <div className="step-no mr-10">3</div>
                  <div className="flex-1">{t('transaction:enterBid')}  </div>
                </div>
                <div className="italic ml-40">
                  {
                    loadTransaction?.matchedLoad?.targetPrice
                      ? (
                        <>
                          {t('transaction:preferredPriceIs', { company: loadTransaction?.matchedLoad?.company?.name || t('transaction:theCompany') })}
                          {' '}
                          <GCurrency value={loadTransaction?.matchedLoad?.targetPrice} />
                          {' '}
                          {loadTransaction?.matchedLoad?.priceType}
                          {' '}
                          {t('transaction:paymentTermsAre')}
                          {' '}
                          {loadTransaction?.matchedLoad?.paymentTerm?.days}
                          {' '}
                          {t('transaction:days')}
                        </>
                      )
                      : <>{t('transaction:noPreferredPrice')}  </>
                  }
                </div>
                <div className="mt-20">
                  <div className="d-flex">
                    <div className="mr-20">
                      <GInput
                        name="bid"
                        errors={errors}
                        onChange={onChange}
                        form={form}
                        type="currency"
                        currency="€"
                        label={`${t('offer:enterYourOffer')} (${loadTransaction?.matchedLoad?.priceType})`}
                        labelclassName="form-label text-12"
                        className="form-input w-auto"
                        placeholder={`${t('offer:yourPrice')} €`}
                      />

                    </div>

                    {loadTransaction.isNegotiable ? (
                      <>
                        <div className="mr-20">
                          <GInput
                            name="paymentTerm"
                            errors={errors}
                            onChange={onChange}
                            form={form}
                            type="number"
                            labelclassName="form-label text-12"
                            label={`${t('offer:paymentTerms')} (${t('offer:optional')})`}
                            className="form-input w-auto"
                            placeholder={`${t('offer:paymentTerms')} ${t('offer:days')}`}
                          />
                        </div>
                      </>
                    ) : null}

                  </div>

                  <GHref
                    onClick={sendBid}
                    submitting={submitting}
                    disableHint={t('offer:bidDisableHint')}
                    disabled={!form.bid || step !== 2 || submitting}
                    className="btn standard-btn   small bold confirm-step-btn-3 mt-16"
                  >
                    {savingRoute
                      ? <>{t('transaction:savingRoute')}   ... </>
                      : <Trans i18nKey="offer:sendBid" />}
                  </GHref>

                </div>
              </div>
            </div>
            {step > 2 && (
              <div className="checked-step">
                <FontAwesomeIcon icon={faCheck} fontSize={24} aria-hidden="true" />
              </div>
            )}
          </div>

        </div>
        {
          step > 2 && <OfferSentMessage type="truck" form={form} />
        }
      </td>
    </tr>

  )
}

export default LoadOffer
